import { useMutation } from 'react-query';

import { createOrUpdateReportComment as mutationFn } from 'api/endPoints/createOrUpdateReportComment';

export interface ICreateEditCommentReportPayload {
    reportId: number | undefined;
    comment: string;
    id: number | null;
    mentionedList: string[];
}

interface CreateReportCommentResponse {
    comment: string;
    commentId: number;
    firstName: string;
    lastName: string;
    reportId: number | null;
    updatedDate: number | null;
    userName: string;
}

export const useMutationCreateEditReportComment = () => {
    return useMutation<CreateReportCommentResponse, QueryError, ICreateEditCommentReportPayload>((params) =>
        mutationFn(params),
    );
};
